<app-loader [hidden]="!isLoading"></app-loader>
<h5>{{ "CONFIG.system_event.header" | translate }}</h5>
<form *ngIf="form && formActive" [hidden]="isLoading" [formGroup]="form" (ngSubmit)="submitForm()">
  <div class="row g-3">
    <div class="col-12 col-lg-6">
      <app-input type="select" formControlName="default_status" appearance="outline"
                 [label]="'CONFIG.system_event.default_status'| translate "
                 [fullWidth]="true" [selectOptions]="statuses" [selectLabel]="'name'" [selectValue]="'id'"
                 [searchable]="true">
      </app-input>
    </div>
    <div class="col-12 col-lg-6">
      <app-input type="select" formControlName="new_creditor" appearance="outline"
                 [label]="'CONFIG.system_event.new_creditor'| translate "
                 [fullWidth]="true" [selectOptions]="statuses" [selectLabel]="'name'" [selectValue]="'id'"
                 [searchable]="true">
      </app-input>
    </div>
    <div class="col-12 col-lg-6">
      <app-input type="select" formControlName="sign_contract" appearance="outline"
                 [label]="'CONFIG.system_event.sign_contract'| translate "
                 [fullWidth]="true" [selectOptions]="statuses" [selectLabel]="'name'" [selectValue]="'id'"
                 [searchable]="true">
      </app-input>
    </div>
    <div class="col-12 col-lg-6">
      <app-input type="select" formControlName="send_contract" appearance="outline"
                 [label]="'CONFIG.system_event.sign_contract'| translate "
                 [fullWidth]="true" [selectOptions]="statuses" [selectLabel]="'name'" [selectValue]="'id'"
                 [searchable]="true">
      </app-input>
    </div>
    <!-- Submit Button -->
    <div class="d-flex justify-content-end mt-4">
      <app-spinner-btn [loading]="isSubmitting" [name]="'SHARED.save' | translate"></app-spinner-btn>
    </div>
  </div>
</form>
